module.exports = __webpack_public_path__ + "img/icon_box_1_4.e99daf28.png";